import React, { Component } from "react";
import PropTypes from "prop-types";
import reactCSS, { hover } from "reactcss";
import { colors } from "assets";

class CheckBox extends Component {
  static propTypes = {
    label: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onCheck: PropTypes.func,
    errorText: PropTypes.string,
    toForm: PropTypes.bool
  };

  static defaultProps = {
    errorText: ""
  };

  constructor(props) {
    super(props);

    this.state = {
      isChecked: this.props.checked,
      error: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.checked !== this.props.checked) {
      this.setState({ isChecked: nextProps.checked });
    }
    if (nextProps.errorText === "") {
      this.setState({ error: false });
    } else {
      this.setState({ error: true });
    }
  }

  render() {
    const styles = reactCSS(
      {
        isChecked: {
          squareIcon: {
            backgroundColor: colors.checkbox.normal,
            border: `1px solid ${colors.checkbox.normal}`,
            borderRadius: 1,
            display: "block",
            margin: 3,
            height: 12,
            minWidth: 12
          }
        },

        error: {
          square: {
            border: "1px solid #FF0014"
          },
          label: {
            color: "#FF0014"
          }
        },

        default: {
          element: {
            margin: "12px 0 0",
            display: "inline-flex",
            cursor: "pointer"
          },
          square: {
            display: "inline-block",
            minWidth: "20px",
            height: "20px",
            border: "1px solid #222",
            borderRadius: "2px",
            textAlign: "center",
            marginRight: "0.5em"
          },
          squareIcon: {
            display: "none"
          },
          label: {
            fontFamily: "Source Sans Pro",
            fontSize: this.props.toForm ? "1em" : 18,
            fontWeight: this.props.toForm ? "bold" : "none",
            marginBottom: 4,
            color: "#222"
          },
          errorText: {
            color: "#FF0014",
            marginTop: 0,
            paddingTop: "0.4em",
            fontSize: 12,
            fontFamily: "Source Sans Pro",
            whiteSpace: "pre-line"
          }
        },
        disabled: {
          element: {
            boxShadow: "none",
            color: "#555",
            opacity: 0.6,
            cursor: "not-allowed"
          }
        }
      },
      this.state,
      this.props
    );

    return (
      <div
        className={`check-box ${this.props.otherClassName}`}
        style={{ ...styles.element, ...this.props.style }}
        onClick={() =>
          !this.props.disabled && this.props.onCheck(!this.state.isChecked)
        }
      >
        <div
          className="square"
          style={{ ...styles.square, ...this.props.checkBoxStyle }}
        >
          <span
            className="square-icon"
            style={{ ...styles.squareIcon, ...this.props.squareIconStyle }}
          ></span>
        </div>
        <div
          className="label"
          style={{ ...styles.label, ...this.props.labelStyle }}
        >
          {this.props.label}
          {this.props.errorText.length > 0 && (
            <div className="error-checkbox" style={styles.errorText}>
              {this.props.errorText}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default hover(CheckBox);



// WEBPACK FOOTER //
// ./src/components/support/check-box/index.jsx